// extracted by mini-css-extract-plugin
export default {"panelTitle":"panel_panelTitle__gQ98+","panelContainer":"panel_panelContainer__1MWkP","children":"panel_children__r6PA0"};